module.exports = __webpack_public_path__ + "static/8-50aa3ec03d3f8eb0f454acd660483457.png";